import React from "react";

export default ({ width = 12, height = 12, fill = "#6D7F92", ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 12 14"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.17912 4.80957H8.82072C10.3923 4.80957 11.6666 6.05571 11.6666 7.59268V10.8839C11.6666 12.4209 10.3923 13.667 8.82072 13.667H3.17912C1.60749 13.667 0.333252 12.4209 0.333252 10.8839V7.59268C0.333252 6.05571 1.60749 4.80957 3.17912 4.80957ZM5.99653 10.5533C6.32847 10.5533 6.59267 10.295 6.59267 9.97034V8.49962C6.59267 8.18163 6.32847 7.92326 5.99653 7.92326C5.67137 7.92326 5.40717 8.18163 5.40717 8.49962V9.97034C5.40717 10.295 5.67137 10.5533 5.99653 10.5533Z"
        fill="#29394D"
      />
      <path
        d="M9.68173 3.9308V4.91128C9.44463 4.84503 9.19399 4.8119 8.93657 4.8119H8.49624V3.9308C8.49624 2.58595 7.37849 1.49285 6.00331 1.49285C4.62814 1.49285 3.51038 2.57932 3.50361 3.91755V4.8119H3.07006C2.80586 4.8119 2.55521 4.84503 2.31812 4.9179V3.9308C2.32489 1.94334 3.97103 0.333496 5.98976 0.333496C8.03559 0.333496 9.68173 1.94334 9.68173 3.9308Z"
        fill="#29394D"
      />
    </svg>
  );
};
